// React
import React, { Component } from 'react';
import { ReactiveBase, ResultList, SelectedFilters } from '@appbaseio/reactivesearch';
import Select from 'react-select';

// Components
import SearchBar from './components/SearchBar';
import SearchToggle from './components/SearchToggle';

class Pages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: 0,
      resultsPerPage: {value: 20, label: 20}
    };
  }

  static renderData (res) {
    let description = "";
    if(res.body) {
      description = res.body[0].replace(/(<([^>]+)>)/ig,"");
      if (description.length > 300) {
        description = description.slice(0, 300) + '...';
      }
    }

    if(res.summary && res.summary[0].length > 0) {
      description = res.summary[0];
    }

    return {
      title: res.title,
      url: res.path_alias,
      description: (
        <div> {description}</div>
      )
    }
  }

  render() {
    const { language, esApp, esUrl } = this.props;
    const { results, resultsPerPage } = this.state;

    let resultsPerPageOptions = [
      { value: 10, label: 10 },
      { value: 20, label: 20 },
      { value: 30, label: 30 },
      { value: 40, label: 40 },
      { value: 50, label: 50 },
      { value: 100, label: 100 }
    ];

    const defaultLangQuery = (value, props) => {
      return {
        query: {
          match: {
            _language: language
          }
        }
      }
    };

    return(
      <div className="Pages">
        <ReactiveBase
          app={esApp}
          url={esUrl}
        >
          <div className="product-search-bar">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="d-md-flex">
                    <div className="flex-grow-1">
                      <SearchBar
                        dataFields={["title", "body"]}
                        primaryField="title"
                        reactSensors={[]}
                        resultCount={results}
                      />
                    </div>
                    <SearchToggle searchType="pages"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container mt-4 mb-4">
            <div className="row">
              <div className="col">
                <SelectedFilters />
                <ResultList
                  componentId="SearchResult"
                  size={resultsPerPage.value}
                  renderData={Pages.renderData}
                  className="result-list-container"
                  pagination={true}
                  innerClass={{pagination: 'pagination d-flex justify-content-center'}}
                  showResultStats={false}
                  onResultStats={({totalResults}) => { this.setState({results: totalResults}) }}
                  react={{
                    and: ['Query']
                  }}
                  onQueryChange={(prevQuery, nextQuery) => {
                    this.setState({esQuery: nextQuery})
                  }}
                  defaultQuery={defaultLangQuery}
                />
                <div className="d-flex justify-content-end products-table-actions">
                  <Select
                    className="results-per-page"
                    value={resultsPerPage}
                    onChange={(selectedOption) => { this.setState({ resultsPerPage: selectedOption }) }}
                    options={resultsPerPageOptions}
                  />
                </div>
              </div>
            </div>
          </div>
        </ReactiveBase>
      </div>
    )
  }
}

export default Pages;
